// @flow

/**
 * Test if given value is not a valid email
 * @param value
 * @returns {boolean} true is value is not a valid email, false if value is a valid email
 */
export const isNotValidEmail = (value: ?string): boolean => {
  return !value || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
};

/**
 * Test if given value is not a valid full name
 * @param value
 * @returns {boolean} true is value is not a valid full name, false if value is a valid full name
 */
export const isNotValidName = (value: ?string): boolean => {
  // return !value || value.trim().split(' ').length < 2;
  return !value || value.length < 3;
};

/**
 * Test if given value is not a valid password
 * Password must have:
 * - At least 8 characters and maximum 50
 * - At least one digit (0-9)
 * - At least one lowercase letter (a-z)
 * - At least one uppercase letter (A-Z)
 * - At least one special character (!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~)
 * - No whitespace
 * @param value
 * @returns {boolean} true is value is not a valid password, false if value is a valid password
 */
export const isNotValidPassword = (value: ?string): boolean => {
  return !value || !/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])(?=\S+$).{8,50}$/i.test(value);
};

/**
 * Test if given value is not a valid phone
 * @param value
 * @returns {boolean} true is value is not a valid phone, false if value is a valid phone
 */
export const isNotValidPhone = (value: ?string): boolean => {
  return !value || !/^[+]?[0-9]{10,}$/i.test(value);
};
